import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 120000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
});
console.log("API Base URL:", process.env.REACT_APP_API_URL);

// Response interceptor
instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token expired veya geçersiz
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export const ApiHelper = {
    setAuthToken: (token) => {
        if (token) {
            instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
            delete instance.defaults.headers.common['Authorization'];
        }
    },

    get: async (url) => {
        return instance.get(url);
    },

    post: async (url, data) => {
        return instance.post(url, data);
    },

    put: async (url, data) => {
        return instance.put(url, data);
    },

    delete: async (url) => {
        return instance.delete(url);
    },
};

// Initialize token from localStorage
const token = localStorage.getItem('token');
if (token) {
    ApiHelper.setAuthToken(token);
}
